import {HTTP} from './common'

export const ReviewApi = {

  resource_stat(start_date, end_date) {
    return HTTP.get(`reviews_stat/resource_stat/?end_date=${end_date||""}&start_date=${start_date||""}`).then(response => {
      return response.data
    });
  },
  full_stat(query) {
    return HTTP.get(`reviews_stat/full_stat/?${query}`).then(response => {
      return response.data
    });
  },
  resource_links_stat(query) {
    return HTTP.get(`reviews_stat/resource_links_stat/?${query}`).then(response => {
      return response.data
    });
  },
  tone_stat(start_date, end_date) {
    return HTTP.get(`reviews_stat/tone_stat/?end_date=${end_date||""}&start_date=${start_date||""}`).then(response => {
      return response.data
    });
  },
  tone_graph_bar(start_date, end_date) {
    return HTTP.get(`reviews_stat/tone_graph_bar/?end_date=${end_date||""}&start_date=${start_date||""}`).then(response => {
      return response.data
    });
  },
  rating_graph_bar(start_date, end_date) {
    return HTTP.get(`reviews_stat/rating_graph_bar/?end_date=${end_date||""}&start_date=${start_date||""}`).then(response => {
      return response.data
    });
  },
  answer_stat(start_date, end_date) {
    return HTTP.get(`reviews_stat/answer_stat/?end_date=${end_date||""}&start_date=${start_date||""}`).then(response => {
      return response.data
    });
  },
  rating_graph(period, start_date, end_date, metric) {
    return HTTP.get(`reviews_stat/rating_graph/?period=${period||""}&start_date=${start_date||""}&end_date=${end_date||""}${metric?'&metric='+metric:""}`).then(response => {
      return response.data
    });
  },

  tone_graph(period, start_date, end_date) {
    return HTTP.get(`reviews_stat/tone_graph/?period=${period||""}&start_date=${start_date||""}&end_date=${end_date||""}`).then(response => {
      return response.data
    });
  },

  daily_tag_statistics(period, start_date, end_date, tags_id) {
    return HTTP.get(`reviews_stat/daily_tag_statistics/?period=${period||""}&start_date=${start_date||""}&end_date=${end_date||""}&tag_ids=${tags_id||""}`).then(response => {
      return response.data
    });
  },

  get_tag_statistics(start_date, end_date, tags_id) {
    return HTTP.get(`reviews_stat/get_tag_statistics/?start_date=${start_date||""}&end_date=${end_date||""}&tag_ids=${tags_id||""}`).then(response => {
      return response.data
    });
  },

  get_reviews(page, size, query) {
    return HTTP.get(`reviews/?page=${page}&size=${size}&${query}`).then(response => {
      return response.data
    });
  },
  update_review(review_id, data) {
    return HTTP.patch(`reviews/${review_id}/update_review/`, data).then(response => {
      return response.data
    });
  }

};

